module.exports = __webpack_public_path__ + "5efaa26f4b8cc0b381059bf84655a918.svg";